module.exports = {
  'en': {
    'HRESH1XC1': {
      '10': 'For Employee',
      '14': 'Disorder From',
      '18': 'To',
      '20': 'Disorder',
      '30': 'Disciplinary action',
      '40': 'Type Of Action',
      '50': 'Punishment Period',
      '60': 'Start',
      '70': 'End',
      '80': 'Remark'
    },
    'HRESH1XC2': {
      '10': 'Details Of Pay Deduction',
      '20': 'Pay Code :',
      '30': 'From Preriod/Month/Year :',
      '40': 'To Preriod/Month/Year :',
      '50': 'Pay Code',
      '60': 'Unit',
      '70': 'Amount',
      '80': '%',
      '90': 'Total'
    },
    'HRPM4GEC2': {
      '10': 'Employee Code',
      '20': 'Effective Date',
      '30': 'Misconduct',
      '40': 'Disciplinary action',
      '50': 'Salary Deduction',
      '60': 'Ref.Doc.No.',
      '70': 'Date of misconduct',
      '80': 'Doc.No.',
      '90': 'Details Of Misconduct',
      '99': 'Action Approve',
      '100': 'Record  By'
    },
    'HRPM4GEC3': {
      '10': 'Seq.No.',
      '20': 'Disp.action Code.',
      '30': 'Type Of Action',
      '40': 'Eff. Date From',
      '50': 'To',
      '60': 'Remarks',
      '70': 'Terminate',
      '80': 'Yes',
      '90': 'No',
      '100': 'Reason of termination',
      '105': 'สาเหตุการสิ้นสุดเป็นผู้ประกันตน',
      '110': 'Record in Blacklist',
      '120': 'Yes',
      '130': 'No',
      '140': 'Update by',
      '150': 'Update date',
      '160': 'Reason of End of the insured'
    },
    'HRPM4GEC4': {
      '10': 'From Period',
      '20': 'Month',
      '30': 'Year',
      '40': 'To Period',
      '50': 'Month',
      '60': 'Year',
      '70': 'Deduction Code',
      '80': 'Deduct From Earning',
      '90': 'Description',
      '100': 'Unit',
      '110': 'Amount',
      '120': 'Deduct %',
      '130': 'Deduct of Amount',
      '140': 'Total Deduct / Period',
      '150': 'Baht',
      '160': 'Total Deduct',
      '170': 'Baht'
    }
  },
  'th': {
    'HRESH1XC1': {
      '10': 'สำหรับพนักงาน',
      '14': 'วันที่ทำผิดตั้งแต่',
      '18': 'ถึง',
      '20': 'วันที่ทำผิด',
      '30': 'ข้อมูลการลงโทษ',
      '40': 'ประเภทการลงโทษ',
      '50': 'ช่วงวันที่ลงโทษ',
      '60': 'เริ่ม',
      '70': 'สิ้นสุด',
      '80': 'หมายเหตุ'
    },
    'HRESH1XC2': {
      '10': 'รายละเอียดการหักเงิน',
      '20': 'รหัสส่วนหัก :',
      '30': 'ตั้งแต่ งวด/เดือน/ปี :',
      '40': 'ถึง งวด/เดือน/ปี :',
      '50': 'รหัสรายได้',
      '60': 'หน่วย',
      '70': 'จำนวนเงินที่หัก',
      '80': '% ที่หัก',
      '90': 'รวม'
    },
    'HRPM4GEC2': {
      '10': 'รหัสพนักงาน',
      '20': 'วันที่มีผลบังคับใช้',
      '30': 'รายละเอียดการกระทำผิด',
      '40': 'รายละเอียดการลงโทษ',
      '50': 'รายละเอียดการหักเงิน',
      '60': 'เลขที่เอกสารอ้างอิง',
      '70': 'วันที่ทำผิด',
      '80': 'ชื่อแฟ้มเอกสาร',
      '90': 'รายละเอียดการกระทำผิด',
      '99': 'อนุมัติการกระทำผิดลงโทษ',
      '100': 'บันทึกโดย'
    },
    'HRPM4GEC3': {
      '10': 'ครั้งที่',
      '20': 'รหัสการลงโทษ',
      '30': 'ประเภทการลงโทษ',
      '40': 'วันที่เริ่มต้น',
      '50': 'ถึง',
      '60': 'หมายเหตุ',
      '70': 'ให้พ้นสภาพการเป็นพนักงาน',
      '80': 'ใช่',
      '90': 'ไม่ใช่',
      '100': 'เหตุผลการออกจากงาน',
      '105': 'สาเหตุการสิ้นสุดเป็นผู้ประกันตน',
      '110': 'บันทึกในบัญชีดำ',
      '120': 'บันทึก',
      '130': 'ไม่บันทึก',
      '140': 'แก้ไขครั้งสุดท้ายโดย',
      '150': 'เมื่อวันที่',
      '160': 'สาเหตุการสิ้นสุดเป็นผู้ประกันตน'
    },
    'HRPM4GEC4': {
      '10': 'ตั้งแต่ งวด',
      '20': 'เดือน',
      '30': 'ปี',
      '40': 'ถึง งวด',
      '50': 'เดือน',
      '60': 'ปี',
      '70': 'รหัสส่วนหัก',
      '80': 'รหัสรายได้',
      '90': 'รายละเอียด',
      '100': 'หน่วย',
      '110': 'จำนวนเงิน',
      '120': 'หัก %',
      '130': 'จำนวนเงินที่หัก',
      '140': 'รวมหักต่องวด',
      '150': 'บาท',
      '160': 'รวมหักทั้งหมด',
      '170': 'บาท'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hresh1x.js